module.exports = "/lucky-balls/img/drum/drum_loop_018.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_018.png
// module id = 1033
// module chunks = 0